import Create from './Create';
import { CreateView } from './Create';
import CreateActions from './CreateActions';
import Edit from './Edit';
import { EditView } from './Edit';
import EditActions from './EditActions';
import EditGuesser from './EditGuesser';
import Show from './Show';
import { ShowView } from './Show';
import ShowActions from './ShowActions';
import ShowGuesser from './ShowGuesser';
import SimpleShowLayout from './SimpleShowLayout';
import TabbedShowLayout from './TabbedShowLayout';
import Tab from './Tab';
import TabbedShowLayoutTabs from './TabbedShowLayoutTabs';
export { Create, CreateView, CreateActions, Edit, EditView, EditActions, EditGuesser, Show, ShowView, ShowActions, ShowGuesser, SimpleShowLayout, TabbedShowLayout, Tab, TabbedShowLayoutTabs, };



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-ui-materialui/esm/detail/index.js
// module id = 1246
// module chunks = 0